import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
import TelecallBook from './TelecallBook';
import TeleCalender from './TeleCalender';
const $= window.$;

class TelecallRequest extends Component {
	constructor(props) {
		super(props);
        this.state={
            
            component : <TelecallBook setCalender={this.Calender.bind(this)} updateComp={this.onChangedComp.bind(this)}/>

        };
        
       
	}


    componentWillReceiveProps(nextProps) {
    	this.setState({
    		component : <TelecallBook setCalender={this.Calender.bind(this)} updateComp={this.onChangedComp.bind(this)}/>
    	})
	}

	onChangedComp(val){
		if(val){
			this.setState({
	    		component : <TelecallBook setCalender={this.Calender.bind(this)} updateComp={this.onChangedComp.bind(this)}/>
			})
		}
	}


	Calender(call_id,tele_id){
		this.setState({
    		component : <TeleCalender call_id={call_id} tele_id={tele_id} ChangedComp={this.onChangedComp.bind(this)}/>
		})
	}


   

    componentDidMount() {
        
    }




		render() {
			
			return (

				<section id="contentsection" className="contentarea">
					<div className="inner-title-bg journey-tit-bg">
						<h1><span><img src={process.env.PUBLIC_URL+"/images/telecalreq-icon.png"} alt="" border="0" align="absmiddle" /></span>Telecalls Request<br /><span className="subtitle">Schedule a one-on-one telecall with your E Coach</span></h1>
					</div>
					{this.state.component}
				</section>

			);
		}
}

export default TelecallRequest;



// WEBPACK FOOTER //
// ./src/personal_interactions/telecall_request/TelecallRequest.js